angular
    .module('webcomm')
    .directive('ngDisableRightClick', ['$parse', function ($parse) {
    return function (scope, element, attrs) {
        element.bind('contextmenu', function (event) {
            scope.$apply(function () {
                event.preventDefault();
                return false;
            });
        });
    };
}]);